import $ from 'jquery';

class Gallery {

    constructor() {
        this.initGallery();

    }

    initGallery() {
        $("[data-fancybox]").fancybox();

    }
}

export default Gallery;
